export default __webpack_public_path__ + "static/media/Main-blog.6cafcce4.png";